import { EventEmitter } from "events";
import dispatcher from "../dispatcher";


class AuthStore extends EventEmitter {
    constructor() {
        super();
        this.token = null;

    }

    getToken() {
        if (!this.token) {
            try {
                this.token = JSON.parse(window.localStorage.getItem("token"));
            } catch (e) {
                this.token = null;
            }
        }
        return this.token;
    }

    setToken(token) {
        this.token = token;
        window.localStorage.setItem("token", JSON.stringify(this.token));
    }

    deleteToken() {
        this.token = null;
        window.localStorage.removeItem("token");
    }

    getFormatedToken() {
        var t = this.getToken();
        var token = "";
        if (t) {
            token = t.token;
            token = "Bearer " + token;
        }
        return token;
    }

    handleAction(action) {
        switch (action.type) {
            case "loginSuccess": {
                this.setToken(action.tokenData);
                this.emit("loginSuccess", action.tokenData.user);
                break;
            }
            case "loginFailed": {
                this.emit("loginFailed");
                break;
            }

            case "passwordRecovered": {
                this.emit("passwordRecovered");
                break;
            }
            case "passwordRecoveryFailed": {
                this.emit("passwordRecoveryFailed");
                break;
            }
            default:
                break;
        }
    }
}

const authStore = new AuthStore();
dispatcher.register(authStore.handleAction.bind(authStore));

export default authStore;


// WEBPACK FOOTER //
// ./src/jsx/store/auth-store.jsx